<template>
  <b-modal
    :id="`modal-somministra-tc-custom-${serviceName}`"
    v-model="isModalVisible"
     :title="`${$t('SomministraCustomTeleconsultoSurvey.compila_questionario')} ${titleName[serviceName]} ${$t('SomministraCustomTeleconsultoSurvey.compilazione_obbligatoria')}`"
    hide-footer
    centered
    size="lg"
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
    aria-modal="true"
  >
    <div
      class="p-4 mx-auto"
      style="max-width: 1200px"
      v-if="suspendable && !showDone"
    >
      <div v-if="survey && !complete">
        <section class="mb-5">
          <h4 class="text-prim-grad-1 text-center fw-bolder text-left pb-1">
            {{ survey.name }}
          </h4>
          <p class="text-justify text-center text-medium-grey fw-bolder">
            {{ survey.description }}
          </p>
        </section>
        <div v-if="survey.info">
          <div v-if="!proceed">
            <p
              class="text-justify mt-2 fs-5 informativa__p"
              v-html="survey.info"
            ></p>
            <b-form-checkbox
              class="text-font-light-grey pb-4 mb-3"
              name="data_consense"
              :value="true"
              :unchecked-value="false"
              v-model="consent"
              :state="consent == true"
            >
              {{$t('SomministraCustomTeleconsultoSurvey.consenso_informativa')}}
            </b-form-checkbox>
            <b-button
              variant="secondary text-white fw-bolder spacing_1"
              :disabled="!consent"
              @click="proceed = true"
              >{{$t('SomministraCustomTeleconsultoSurvey.procedi')}}</b-button
            >
          </div>
          <div v-else>
            <CompilatoreQuestionario
              :survey="{ ...survey }"
              :patient="user"
              v-on:filled-form="onFilledForm"
            />
          </div>
        </div>
        <div v-else>
          <CompilatoreQuestionario
            :survey="{ ...survey }"
            :patient="user"
            v-on:filled-form="onFilledForm"
          />
        </div>
      </div>
    </div>
    <div class="mt-5 shadowedCard p-4" v-else-if="showDone">
      <h5>{{$t('SomministraCustomTeleconsultoSurvey.questionario_gia_compilato')}}</h5>
      <router-link :to="{ name: 'agenda' }">
        <b-button variant="secondary spacing_1 m-2">{{$t('SomministraCustomTeleconsultoSurvey.vai_agenda')}}</b-button>
      </router-link>
    </div>
  </b-modal>
</template>

<script>
import {
  supportService,
  cittadinoService,
  reservationService,
} from "@/_services";
import { mapState, mapActions } from "vuex";
import CompilatoreQuestionario from "@/app/modules/servizi/screening/components/CompilatoreQuestionario.vue";

export default {
  name: "SomministraCustomTeleconsultoSurvey",
  components: {
    CompilatoreQuestionario,
  },
  props: ["serviceName"],
  computed: {
    ...mapState({
      alert: (state) => state.alert,
      mustFillSurvey: (state) => state.tcsurvey.mustFillSurvey
    }),
    ...mapState("utente", ["status", "user"]),
    areServiceReservationAndServiceNameCompatible() {
      if (
        !this.reservation ||
        !this.reservation.service ||
        !this.reservation.service.name
      ) {
        return false
      }

      const serviceNameLower = this.reservation.service.name.toLowerCase()

      return (
        (this.serviceName === "emergenza" &&
          serviceNameLower.includes("rapido")) ||
        (this.serviceName === "tc_pediatrico" &&
          serviceNameLower.includes("pediatrico"))
      )
    },
    isModalVisible: {
      get() {
        return (
          this.mustFillSurvey && this.areServiceReservationAndServiceNameCompatible
        )
      },
      set(value) {
        if (!value) {
          this.setMustFillSurvey(false)
        }
      }
    },
  },
  data() {
    return {
      survey: null,
      consent: false,
      proceed: false,
      complete: false,
      suspendable: null,
      showDone: false,
      titleName: {
        tc_pediatrico: "Pediatrico",
        emergenza: "Rapido",
      },
      reservation: null,
    };
  },
  watch: {
    mustFillSurvey(value) {
      if (value) {
        this.openAndBlock(true);
        this.fetchData();
      }
    },
  },
  methods: {
    ...mapActions({
      clearAlert: "alert/clear",
      errorAlert: "alert/error",
      successAlert: "alert/success",
      infoAlert: "alert/info",
      setHasFilledSurvey: "tcsurvey/setHasFilledSurvey",
      setMustFillSurvey: "tcsurvey/setMustFillSurvey",
      clearTcsurvey: "tcsurvey/clear",
      openAndBlock: "modal/openAndBlock",
      clearModal: "modal/clear",
    }),
    fetchData() {
      const self = this;
      reservationService
        .getUserPendingCustomTcReservation(this.serviceName)
        .then(function (res) {
          if (
            res.data.data.has_pending &&
            res.data.data.reservation &&
            res.data.data.reservation.suspended_survey
          ) {
            self.reservation = res.data.data.reservation;
            self.getSuspendedSurvey(
              res.data.data.reservation.suspended_survey.hashid
            );
          }
        })
        .catch(function (err) {
          window.scrollTo(0, 0);
          self.errorAlert(self.$t('SomministraCustomTeleconsultoSurvey.errore_recupero_attivita'));
          self.clearModal();
        });
    },
    getSuspendedSurvey(surveyHashid) {
      const self = this;
      supportService
        .getSuspendedSurveyById(surveyHashid)
        .then(function (surveyRes) {
          self.survey = surveyRes.data.data.survey;
          self.suspendable = surveyRes.data.data;
          self.consent = surveyRes.data.data.survey.info == null;
        })
        .catch(function (err) {
          if (err.status == 404) {
            self.showDone = true;
            self.setHasFilledSurvey(true);
            self.clearModal();
          } else {
            window.scrollTo(0, 0);
            self.errorAlert(self.$t('SomministraCustomTeleconsultoSurvey.errore_recupero_attivita'));
            self.clearModal();
          }
        });
    },
    onFilledForm(filled) {
      // CompilatoreQuestionario emette l'oggetto survey con le risposte in
      // template.domande: estrae l'array compilato e riusa il flusso d'invio esistente.
      const domande =
        filled && filled.template && Array.isArray(filled.template.domande)
          ? filled.template.domande
          : [];
      this.handleFilledSurvey(domande);
    },
    handleFilledSurvey(form) {
      const temp = {
        info: this.survey.info,
        nome: this.survey.name,
        domande: form,
      };
      const formData = {
        response: JSON.stringify(temp),
        suspended: this.suspendable.hashid,
      };

      const self = this;
      cittadinoService
        .storeSuspendedFilledSurvey(formData)
        .then(function (res) {
          self.complete = true;
          self.setHasFilledSurvey(true);
          self.clearTcsurvey();
          window.scrollTo(0, 0);
          self.successAlert(self.$t('SomministraCustomTeleconsultoSurvey.successo_questionario'));
          self.$bvModal.hide(`modal-somministra-tc-custom-${self.serviceName}`);
          self.clearModal();
        })
        .catch(function (err) {
          window.scrollTo(0, 0);
          self.errorAlert(self.$t('SomministraCustomTeleconsultoSurvey.errore_questionario'));
          self.clearModal();
        });
    },
  },
  created() {
    if (this.mustFillSurvey) {
      this.openAndBlock(true);
      this.fetchData();
    }

    // setInterval(() => {
    //   console.log(
    //     "reservation: ",
    //     JSON.stringify(this.reservation),
    //     "serviceName: ",
    //     this.serviceName
    //   );
    // }, 4000);
  },
  beforeDestroy() {
    this.clearModal();
  },
};
</script>
